import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Waitlist from 'src/components/tournaments/participants/Waitlist';
import SearchBar from 'src/components/tournaments/participants/SearchBar';
import ParticipantFill from 'src/components/tournaments/participants/ParticipantFill';
import WaitlistToggle from 'src/components/tournaments/participants/WaitlistToggle';
import RegisteredParticipants from 'src/components/tournaments/participants/RegisteredParcticipants';
import SearchQuery from 'src/components/tournaments/participants/SearchQuery';
import { AccordionCompetitorProps } from 'src/components/tournaments/participants/accordion-competitor/AccordionCompetitor';
import { useState, useEffect, useRef } from 'react';
import { Tournament } from 'functions/src/types/firestore/Game/Tournament';
//TODO: add prop size

export type ParticipantTabProps = {
  tournament: Tournament<Date>;
  registration: AccordionCompetitorProps[];
  waitlist: AccordionCompetitorProps[];
};

export const ParticipantTab = ({
  tournament,
  registration,
  waitlist,
}: ParticipantTabProps) => {
  // CALCULATE WAITLIST SIZE
  const waitlistTotal: number = waitlist
    .map((entry) => {
      return entry.currentTeamFill;
    })
    .reduce((a, b) => {
      return a + b;
    }, 0);

  // CALCULATE REGISTERED PARTICIPANT SIZE
  const registeredTotal: number = registration
    .map((entry) => {
      return entry.currentTeamFill;
    })
    .reduce((a, b) => {
      return a + b;
    }, 0);

  const [regData, setRegData] = useState<AccordionCompetitorProps[]>([]);
  const [waitlistData, setWaitlistData] = useState<AccordionCompetitorProps[]>(
    [],
  );
  const [isSwitchActive, setIsSwitchActive] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [noRegSearchResults, setNoRegSearchResults] = useState<boolean>(false);
  const [noWaitlistSearchResults, setNoWaitlistSearchResults] =
    useState<boolean>(false);
  const queryInputRef = useRef<HTMLInputElement>();

  // TODO: refactor this logic
  // MAKE A COPY OF DEFAULT DATA TO BE USED FOR FILTERING
  useEffect(() => {
    setRegData(registration);
    const waitlistOrdered = waitlist.sort((a, b) => {
      return (
        (a.registrationTime?.getTime() || 0) -
        (b.registrationTime?.getTime() || 0)
      );
    });
    setWaitlistData(waitlistOrdered);
  }, []);

  // QUERY FUNCTION: CURRENTLY CAN ONLY SEARCH BY TEAM NAME, USERNAME, SOLO STATUS, CAPTAIN STATUS
  // RETURNS ENTIRE ENTRY (TEAM OR SOLO)
  // NO AUTOCOMPLETE FUNCTIONALITY
  function queryFn(
    data: AccordionCompetitorProps[],
    query: string,
  ): AccordionCompetitorProps[] {
    const param1 = data.filter(function (entry) {
      return entry.teamName.toLowerCase().replace(/\s/g, '').includes(query);
    });
    const param2 = data.filter(function (entry) {
      return entry.participants.some((competitor) => {
        return competitor?.username
          .toLowerCase()
          .replace(/\s/g, '')
          .includes(query);
      });
    });
    const param3 = data.filter(function (entry) {
      return entry.participants.some((competitor) => {
        return competitor?.status.includes(query);
      });
    });
    return Array.from(new Set(param1.concat(param2, param3)));
  }

  const cleanSearch = async () => {
    setNoRegSearchResults(false);
    setNoWaitlistSearchResults(false);
    setRegData(registration);
    setWaitlistData(waitlist);
  };
  // CLEAR SEARCH QUERY AND REVERT DISPLAYED DATA TO DEFAULT DATA
  const clearSearchHandler = async () => {
    setSearchQuery('');
    await cleanSearch();
  };
  // APPLY SEARCH QUERY TO COPY OF DATA
  const queryHandler = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    setSearchQuery(queryInputRef?.current.value);

    const query = queryInputRef?.current.value.toLowerCase().replace(/\s/g, '');
    const filteredRegData = queryFn(registration, query);
    const filteredWaitlistData = queryFn(waitlist, query).sort((a, b) => {
      return a?.waitlistPosition - b?.waitlistPosition;
    });

    setRegData(filteredRegData);
    setWaitlistData(filteredWaitlistData);
    setNoRegSearchResults(false);
    setNoWaitlistSearchResults(false);

    if (filteredRegData.length <= 0) {
      setNoRegSearchResults(true);
    }
    if (filteredWaitlistData.length <= 0) {
      setNoWaitlistSearchResults(true);
    }

    queryInputRef.current.value = '';
  };

  // TOGGLE TO VIEW WAITLIST
  const toggleWaitlistHandler = () => {
    setIsSwitchActive(!isSwitchActive);
  };

  return (
    <>
      <Box sx={{ px: { xs: 4, md: 20, lg: 45 }, maxWidth: '100vw' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <ParticipantFill
            currentFill={registeredTotal}
            maxFill={tournament.maxTeamSize * tournament.maxTeamCount}
          />
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'stretch',
            flexDirection: 'row',
            gap: 2,
          }}
        >
          <WaitlistToggle
            toggleWaitlist={toggleWaitlistHandler}
            numWaitlist={waitlistTotal}
          />
          <SearchBar queryHandler={queryHandler} inputRef={queryInputRef} />
          {searchQuery && (
            <SearchQuery
              query={searchQuery}
              clearSearchHandler={clearSearchHandler}
            />
          )}
        </Box>

        {((!isSwitchActive && noRegSearchResults) ||
          (isSwitchActive && noWaitlistSearchResults)) && (
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 8 }}>
            <Typography variant="h5">No results found.</Typography>
          </Box>
        )}
        {isSwitchActive ? (
          <Waitlist data={waitlistData} teamMax={tournament.maxTeamSize} />
        ) : (
          <RegisteredParticipants
            data={regData}
            teamMax={tournament.maxTeamSize}
          />
        )}
      </Box>
    </>
  );
};
